import React, { useState, useEffect } from "react";
import {
  AppBar,
  Avatar,
  Button,
  Toolbar,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
  InputBase,
} from "@material-ui/core";
// import useStyles from "./style";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import decode from "jwt-decode";
import InstagramIcon from "@mui/icons-material/Instagram";

import { Menu, MenuItem } from "@material-ui/core";

export const Navbar = () => {
  //const classes = useStyles();
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const uid=user?.result?._id;
  console.log(uid)

  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));
  const [open,setOpen]=useState(false)
  const logout = () => {
    dispatch({ type: "LOGOUT" });
    navigate("/auth");
    setUser(null);
  };

  useEffect(() => {
    const token = user?.token;
    if (token) {
      const decodedtoken = decode(token, { header: true });
      if (decodedtoken.exp * 1000 < new Date().getTime()) logout();
    }
    setUser(JSON.parse(localStorage.getItem("profile")));
  }, [location]);

  const StyledToolbar = styled(Toolbar)({
    display: "flex",
    justifyContent: "space-between",
  });
  const Search = styled("div")(({ theme }) => ({
    backgroundColor: "White",
    padding: "0 8px",
    borderRadius: theme.shape.borderRadius,
    width: "30%",
  }));
  return (
    <AppBar>
      <StyledToolbar>
        {isMatch ? (
          <InstagramIcon />
        ) : (
          <Typography variant="h6">IndianGram</Typography>
        )}
        <Search>
          <InputBase placeholder="Search" />
        </Search>

        {user ? (
          <div>
            <Avatar alt={user?.result?.name} src={user?.result?.Profilepic} onClick={e=>setOpen(true)}/>
          </div>
        ) : (
          <div>
            <Button component={Link} to="/auth" variant="contained">
              Login
            </Button>

          </div>
        )}
        <Menu
          id="demo-positioned-menu"
          aria-labelledby="demo-positioned-button"
          open={open}
          onClose={e=>setOpen(false)}
          anchorOrigin={{
            vertical: "Top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "Top",
            horizontal: "right",
          }}
        >
        {user?(
          <div>
              <MenuItem component={Link} to={`/Profile?uid=${uid}`}>Profile</MenuItem>
              <MenuItem onClick={logout} >Logout</MenuItem>
          </div>):(<div></div>)}
         
        </Menu>
      </StyledToolbar>
    </AppBar>
  );
};
